import Vue from 'vue'
import { Component } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import reportUtils from '@/views/reports/report-utils';
import UrlMixin from '@/components/query/url-mixin';

interface BookmarkIndexed extends Bemob.Bookmark {
  titleLowerCase: string;
  index: number;
}

@Component
export default class BookmarkListMixin extends mixins(UrlMixin) {
  get bookmarks(): BookmarkIndexed[] {
    const bookmarks = this.$store.state.bookmarks as Bemob.Bookmark[];

    return bookmarks.map((item, index) => ({
      ...item,
      titleLowerCase: item.title ? item.title.toLowerCase() : '',
      index: index
    }));
  }

  get utils(){
    return reportUtils(this);
  }

  handleDelete(index: number) {
    this.$store.commit('removeBookmark', index);
  }

  openBookmark(item: BookmarkIndexed) {
    this.$nextTick(() => {
      this.close();
    });
    
    return this.utils.resolveReportNavigation(this.drilldown, {
      isAddTab: true,
      tabData: item.tabData
    });
  }

  openDeleteDialog(index: number) {
    this.bus.emit('open-dialog', { name: 'ConfirmDialog', data: {
        message: this.t('Are you sure you want to delete this bookmark?'),
        onConfirm: () => this.handleDelete(index),
      }})

  }

  handleOpenBookmark(item: BookmarkIndexed, immediate: boolean = false) {
    const normalizedPathUrl = this.normalizeUrl(this.$route.fullPath);
    const normalizedItemUrl = this.normalizeUrl(item.url);

    if(normalizedItemUrl === normalizedPathUrl) {
      this.openBookmark(item).then(() => {
        this.bus.emit('reload-lives');
        this.bus.emit('reload-conversions');
        this.bus.emit('reload-errors');
      });
    } else {
      const cb = () => {
        this.$router.push(item.url, () => {
          this.$nextTick(() => {
            this.openBookmark(item);
            this.bus.emit('get-report');
          });
        });
      }

      if(immediate) {
        this.close();
        this.$store.commit('loading', true);
        this.$helpers.afterBrowserRedraw(cb);
      } else {
        cb();
      }
    }
  }

  close() {}
}
